<template>
  <div class="py-2 my-2 help-container">
    <h1 class="separator py-4">OCCUPANCY WORKSHEET > TOP SUMMARY SECTION</h1>
    <span class="banner py-3 mb-4">
      <div>You are seeing the summary information that was entered in the four tabs contained in these worksheets, which will allow you to establish your Occupancy, Vacancy Loss, Loss/Gain to Lease, Concessions and Bad Debt Write Off amounts.</div>
    </span>

    <!--Help Sections-->
    <v-expansion-panels v-model="openSectionInternal">
      <v-expansion-panel>
        <v-expansion-panel-header :color="getSectionColorFor(0)">
          <v-icon small class="icon" slot="actions" :color="getIconColorFor(0)">$vuetify.icons.expand</v-icon>
          <span class="header pl-3"><strong>Options</strong></span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="help-content">
          <div>The options at the top allow these customizations:</div>
          <ul>
            <li>Detail View - will display all rows</li>
            <li>Summary View - will display Gross Potential Rent, Net Rental Income, Physical Occupancy, and Economic Occupancy.</li>
            <li>Select to add YearOverYear Variance Dollar and YearOverYear Variance Percent columns.</li>
            <li class="no-bullet">
              <ul>
                <li>
                  <strong>YOY Variance $</strong>: The current year Total column - The prior year Market Rents
                </li>
                <li>
                  <strong>YOY Variance $</strong>: The current year Total column - The prior year Market Rents/prior year Market Rents
                </li>
              </ul>
            </li>
          </ul>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header :color="getSectionColorFor(1)">
          <v-icon small class="icon" slot="actions" :color="getIconColorFor(1)">$vuetify.icons.expand</v-icon>
          <span class="header pl-3"><strong>Calculations</strong></span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="help-content">
          <div><strong>Gross Potential Rent</strong> - Pulled from the Gross Potential Rent on the Occupancy summary page.</div>
          <div><strong>Loss/Gain to Lease</strong> - Gross Potential Rent - Vacancy Loss - Actual Rent.</div>
          <ul>
            <li>
              This calculation is shown at the bottom of the Actual Rent tab
            </li>
          </ul>
          <div><strong>Vacancy Loss</strong> - The number of vacant units at the end of the month x Market Rent for that month.</div>
          <ul>
            <li>
              The calculation is shown in detail on the bottom of the Move Ins / Outs tab.
            </li>
          </ul>
          <div><strong>Vacancy Loss (Model/Admin/Down)</strong> - The number of units reserved as Models, Administrative or Down units x Market Rent for that month.</div>
          <ul>
            <li>
              The calculation is shown in detail on the bottom of the Model / Admin / Down tab.
            </li>
          </ul>
          <div><strong>Rental Deductions</strong> - The total Concessions amount from the Rental Deductions tab.</div>
          <div><strong>Bad Debt</strong> - The total Bad Debt amount from the Rental Deductions tab.</div>
          <div><strong>Net Rental Income</strong> - Gross Potential Rent - Loss/Gain to Lease - Vacancy Loss - concessions - bad debt.</div>
          <div><strong>Average Market Rent</strong> - Net Rental Income / Total Number of Units</div>
          <div><strong>AMR per Square Feet</strong> - Net Rental Income / Total Square Footage</div>
          <div><strong>Physical Occupancy</strong> - Ending Vacant Units / Total Units</div>
          <div><strong>Economic Occupancy</strong> - Calculation based on your settings in Admin > Settings > Reports > Economic Occupancy</div>
          <div><strong>Ending Occupied Units</strong> - Result of your choices on the Move Ins / Outs tab.  Details at the bottom of that tab.</div>
          <div><strong>Ending Vacant Units</strong> - Result of your choices on the Down / Admin / Model tab + your choices on the Move Ins / Outs tab.  Details will be displayed at the bottom of both of those tabs</div>
          <div><strong>Total Units</strong> - Total units on the property</div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel readonly>
        <v-expansion-panel-header>
          <v-icon slot="actions"></v-icon>
          <span class="black--text pointer">Prefer to watch a video? <a @click="openExternalTopic('BudgetsPro Occupancy')">Click Here</a></span>
        </v-expansion-panel-header>
      </v-expansion-panel>
      <v-expansion-panel readonly>
        <v-expansion-panel-header>
          <v-icon slot="actions"></v-icon>
          <span class="black--text pointer">Want to see all BudgetsPro help articles? <a @click="openExternalTopic('BudgetsPro')">Click Here</a></span>
        </v-expansion-panel-header>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import HelpMixin from '@/mixins/Help.js'
  export default {
    name: 'OccupancySummaryHelp',
    mixins: [HelpMixin]
  }
</script>

<style lang="scss" scoped>
  .no-bullet {
    list-style-type: none;
  }
  .icon {
      order: 0;
  }
  .header {
      order: 1;
  }
  .help-container {
      border-bottom: 1px solid var(--v-resGrey-lighten1)
  }
  .help-content div,
  .help-content li {
      margin-top:10px !important;
      margin-bottom:10px !important;
  }
  .banner {
    text-align: center;
    background-color: var(--v-resGrey-lighten1);
    display: block;
  }
  .pointer {
      cursor: pointer !important;
  }
  .separator {
    display: flex;
    align-items: center;
    text-align: center;
  }
  .separator::before,
  .separator::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid var(--v-resGrey-darken1);
  }

  .separator:not(:empty)::before {
    margin-right: .25em;
  }

.separator:not(:empty)::after {
  margin-left: .25em;
}
</style>
